import { render, staticRenderFns } from "./StockOrderAddressPicker.vue?vue&type=template&id=61520fc5"
import script from "./StockOrderAddressPicker.vue?vue&type=script&lang=js"
export * from "./StockOrderAddressPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports